/** @format */

import SimCardList from '../views/SimCard/SimCardList';
import { PricelistList } from '../views/Pricelists/PricelistList';
import IccidEdit from '../views/iccid-pools/IccidEdit';
import IccidCommon from '../views/iccid-pools/IccidCommon';
import PlatformResellerAdd from '../views/PlatformReseller/PlatformResellerAdd';
import ClientsEdit from '../views/Clients/ClientsEdit';
import ClientsAdd from '../views/Clients/ClientsAdd';
import SimCardAdd from '../views/SimCard/SimCardAdd';
import SimCardViewCommon from '../views/SimCard/SimCardViewCommon';
import Dashboard from '../views/Dashboard/Dashboard';
import PlatformReseller from '../views/PlatformReseller/PlatformReseller';
import IpList from '../views/Storage/StorageIp';
import IccidList from '../views/Storage/StorageImsi';
import PlkList from '../views/Provisioning/PlkList';
import ApiList from '../views/Provisioning/ApiList';
import MvnoBlockRequestList from '../views/Provisioning/MvnoBlockRequestList';
import NotificationList from '../views/Provisioning/NotificationList';
import ReturnE14List from '../views/Mnp/ReturnE14List';
import ReturnE40List from '../views/Mnp/ReturnE40List';
import ViewPlkList from '../views/Provisioning/view/ViewPlkList';
import BlockView from '../views/Provisioning/view/BlockView';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PlatformResellerIcon from '@material-ui/icons/LocalPlay';
import Notifications from '@material-ui/icons/Storage';
import Image from '@material-ui/icons/Image';
import People from '@material-ui/icons/People';
import Tariffs from '@material-ui/icons/SwapCalls';
import Unarchive from '@material-ui/icons/Unarchive';
import Money from '@material-ui/icons/Money';
import { Database, FileCogOutline } from 'mdi-material-ui/index';
import PortInList from '../views/Mnp/PortInList';
import PortOutList from '../views/Mnp/PortOutList';
import MnpAllList from '../views/Mnp/MnpAllList';
import StorageMsisdn from '../views/Storage/StorageMsisdn';
import FileInterface from '../views/FileInterface/FileInterface';
import Product from '../views/SimCard/Product';
import { MsisdnDetail } from '../views/Storage/msisdn/MsisdnDetail';
import { ImsiDetail } from '../views/Storage/imsi/ImsiDetail';
import { IpDetail } from '../views/Storage/ip/IpDetail';
import PlatformUserList from '../views/PlatformReseller/PlatformUserList';
import { PlatformUserEdit } from '../views/PlatformReseller/PlatformUserEdit';
import { PlatformUserAdd } from '../views/PlatformReseller/PlatformUserAdd';
import { BillingList } from '../views/Tariffing/BillingList';
import PlatformResellerEdit from '../views/PlatformReseller/PlatformResellerEdit';
import Certificate from '../layouts/Certificate';
import NumberRangeEdit from '../views/NumberRange/NumberRangeEdit';
import ServiceList from '../views/Features/ServiceList';
import { ServiceEdit } from '../views/Features/ServiceEdit';
import { MvnoBlockEdit } from '../views/Block/MvnoBlockEdit';
import MvnoBlockList from '../views/Block/MvnoBlockList';
import ServiceCodeList from '../views/ServiceCode/ServiceCodeList';
import { ServiceCodeEdit } from '../views/ServiceCode/ServiceCodeEdit';
import { ServiceCodeAdd } from '../views/ServiceCode/ServiceCodeAdd';
import UserPermissionGroupList from '../views/PermissionGroups/UserPermissionGroupList';
import { UserPermissionGroupEdit } from '../views/PermissionGroups/UserPermissionGroupEdit';
import { UserPermissionGroupAdd } from '../views/PermissionGroups/UserPermissionGroupAdd';
import TariffList from '../views/Tariffing/Tariffs/TariffList';
import TariffAdd from '../views/Tariffing/Tariffs/TariffAdd';
import { TariffEdit } from '../views/Tariffing/Tariffs/TariffEdit';
import { Rmo } from '../views/Rmo/Rmo';
import MnoMessageList from '../views/MnoMessage/MnoMessageList';
import MsisdnPoolManager from '../views/Storage/pools/MsisdnPoolManager';
import ImsiPoolManager from '../views/Storage/pools/ImsiPoolManager';
import IpPoolManager from '../views/Storage/pools/IpPoolManager';
import ServiceTemplateList from '../views/Features/ServiceTemplateList';
import { ServiceTemplateEdit } from '../views/Features/ServiceTemplateEdit';
import InvoiceList from '../views/Documents/Invoices/InvoiceList';
import SpecializedReport from '../views/Reports/SpecializedReport/SpecializedReport';
import ARReportList from '../views/Documents/Reports/ARReportList';
import { ServiceProfileList } from '../views/Features/ServiceProfileList';
import { ServiceProfileEdit } from '../views/Features/ServiceProfileEdit';
import FractionList from '../views/Tariffing/Fraction/FractionList';
import FractionEdit from '../views/Tariffing/Fraction/FractionEdit';
import PrefixList from '../views/Prefixes/PrefixList';
import PrefixAdd from '../views/Prefixes/PrefixAdd';
import { PrefixEdit } from '../views/Prefixes/PrefixEdit';
import FractionAdd from '../views/Tariffing/Fraction/FractionAdd';
import { ReactComponent as Sim } from '../assets/themes/OPL/img/icons/Sim.svg';
import { ReactComponent as Storage } from '../assets/themes/OPL/img/icons/Storage.svg';
import { ReactComponent as Device } from '../assets/themes/OPL/img/icons/Device.svg';
import { ReactComponent as DataTraffic } from '../assets/themes/OPL/img/icons/DataTraffic.svg';
import { ReactComponent as Graph } from '../assets/themes/OPL/img/icons/Graph.svg';
import { ReactComponent as Settings } from '../assets/themes/OPL/img/icons/Settings.svg';
import { ReactComponent as PaymentCard } from '../assets/themes/OPL/img/icons/PaymentCard.svg';
import VirtualComponent from '../views/VirtualComponent/VirtualComponent';
import { VirtualComponentEdit } from '../views/VirtualComponent/VirtualComponentEdit';
import Retarification from '../views/Retarification/Retarification';
import NotificationConfiguration from '../views/NotificationConfiguration/NotificationConfiguration';
import WelcomeSmsConfiguration from '../views/NotificationConfiguration/WelcomeSmsConfiguration/WelcomeSmsConfiguration';
import ServicesActivation from '../views/ServicesActivation/ServicesActivation';
import FupHistoryList from '../views/SimCard/FupHistoryList';
import PrefixesUploadList from '../views/Prefixes/Import/PrefixesUploadList';
import { LinearBillingList } from '../views/PricelistReforged/LinearBillingList';
import ServiceListManager from '../views/Features/Manager/ServiceListManager';
import ComponentZoneConfiguration from '../views/NotificationConfiguration/ComponentZoneConfiguration/ComponentZoneConfiguration';
import BlockQueueDashboard from '../views/Analytics/Dashboard/BlockQueueDashboard';
import MvnoBlockErrorManagement from '../views/Block/BlockListError/BlockErrorManagement';
import PlatformMsisdnRangePoolList from '../views/msisdn-pools/component/PlatformMsisdnRangePoolList';

export const DynamicElements = {
    SimCardList: SimCardList,
    FractionAdd: FractionAdd,
    FractionList: FractionList,
    FractionEdit: FractionEdit,
    PricelistList: PricelistList,
    MsisdnView: MsisdnDetail,
    IccidEdit: IccidEdit,
    IccidCommon: IccidCommon,
    IccidViewCommon: ImsiDetail,
    IpCommon: IpDetail,
    PlatformResellerEdit: PlatformResellerEdit,
    PlatformResellerAdd: PlatformResellerAdd,
    ClientsEdit: ClientsEdit,
    ClientsAdd: ClientsAdd,
    SimCardAdd: SimCardAdd,
    SimCardViewCommon: SimCardViewCommon,
    Dashboard: Dashboard,
    Certificate: Certificate,
    PlatformReseller: PlatformReseller,
    PlatformUserList: PlatformUserList,
    PlatformUserEdit: PlatformUserEdit,
    PlatformUserAdd: PlatformUserAdd,
    IpList: IpList,
    IccidList: IccidList,
    MsisdnList: StorageMsisdn,
    PlkList: PlkList,
    ApiList: ApiList,
    PortoutList: PortOutList,
    PortinList: PortInList,
    BlockList: MvnoBlockRequestList,
    NotificationList: NotificationList,
    ReturnE14List: ReturnE14List,
    ReturnE40List: ReturnE40List,
    SimCardEdit: Product,
    ViewPlkList: ViewPlkList,
    BillingList: BillingList,
    BlockView: BlockView,
    MnpAllList: MnpAllList,
    FileInterface: FileInterface,
    NumberRangeEdit: NumberRangeEdit,
    Rmo: Rmo,
    ServiceList: ServiceList,
    ServiceEdit: ServiceEdit,
    MvnoBlockEdit: MvnoBlockEdit,
    MvnoBlockList: MvnoBlockList,
    ServiceCodeList: ServiceCodeList,
    ServiceCodeEdit: ServiceCodeEdit,
    ServiceCodeAdd: ServiceCodeAdd,
    UserPermissionGroupList: UserPermissionGroupList,
    UserPermissionGroupEdit: UserPermissionGroupEdit,
    UserPermissionGroupAdd: UserPermissionGroupAdd,
    TariffList: TariffList,
    TariffAdd: TariffAdd,
    TariffEdit: TariffEdit,
    MnoMessageList: MnoMessageList,
    MsisdnPoolManager: MsisdnPoolManager,
    ImsiPoolManager: ImsiPoolManager,
    IpPoolManager: IpPoolManager,
    ServiceTemplateList: ServiceTemplateList,
    ServiceTemplateEdit: ServiceTemplateEdit,
    InvoiceList: InvoiceList,
    SpecializedReport: SpecializedReport,
    ARReportList: ARReportList,
    ServiceProfileList: ServiceProfileList,
    ServiceProfileEdit: ServiceProfileEdit,
    PrefixList: PrefixList,
    PrefixAdd: PrefixAdd,
    PrefixEdit: PrefixEdit,
    VirtualComponent: VirtualComponent,
    VirtualComponentEdit: VirtualComponentEdit,
    Retarification: Retarification,
    NotificationConfiguration: NotificationConfiguration,
    WelcomeSmsConfiguration: WelcomeSmsConfiguration,
    ServicesActivation: ServicesActivation,
    FupHistoryList: FupHistoryList,
    PrefixesUploadList: PrefixesUploadList,
    LinearBillingList: LinearBillingList,
    ServiceListManager: ServiceListManager,
    ComponentZoneConfiguration: ComponentZoneConfiguration,
    BlockQueueDashboard: BlockQueueDashboard,
    MvnoBlockErrorManagement: MvnoBlockErrorManagement,
    PlatformMsisdnRangePool: PlatformMsisdnRangePoolList,

    // icons
    DashboardIcon: DashboardIcon,
    PlatformResellerIcon: PlatformResellerIcon,
    Storage: Storage,
    Image: Image,
    People: People,
    Receipt: PaymentCard,
    Tariffs: Tariffs,
    Provisioning: Device,
    Configuration: Settings,
    Mnp: DataTraffic,
    SimCard: Sim,
    Unarchive: Unarchive,
    Money: Money,
    Notifications: Notifications,
    Database: Database,
    FileCogOutline: FileCogOutline,
    Assessment: Graph,
};
